export const CONVERSATION_MUTE_OPTIONS = [
  { translationKey: 'inbox.mute1h', durationHours: 1 },
  { translationKey: 'inbox.mute8h', durationHours: 8 },
  { translationKey: 'inbox.mute1w', durationHours: 24 * 7 },
  { translationKey: 'inbox.muteForever', durationHours: null },
] as const;
